/**
 * @desc 收款单
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(boOrderNo: string, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/getReceiptDetail/${boOrderNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
